import {
  Disclaimer,
  Div,
  Pill,
  TooltipIcon,
  lightTheme,
} from '@vgrubs/components';

const TOOLTIP = "Orders from this brand are sent to the location's POS.";

export const PushOrdersToPosPill = ({
  pushOrdersToPos,
  isPos,
}: {
  pushOrdersToPos?: boolean;
  isPos: boolean;
}) => {
  // The flag lives on the brand whatever the location does with it, so it can
  // read as enabled on a location that has no POS at all. Only say so where it
  // actually means something.
  if (!isPos || !pushOrdersToPos) return null;
  return (
    <Pill $background={lightTheme.primary} $gap="6px">
      <Disclaimer $m="0" $color={lightTheme.white}>
        Push to POS Enabled
      </Disclaimer>

      {/* Every surface that renders this pill sits inside a row that navigates
          on click, so the tap that opens the tooltip must not reach it. */}
      {/* lineHeight 0 kills the inline-baseline gap under the svg, which
          otherwise pushes the icon a couple of pixels below the text. */}
      <Div
        $flex
        $alignCenter
        style={{ lineHeight: 0 }}
        onClick={(e) => e.stopPropagation()}
      >
        <TooltipIcon tooltip={TOOLTIP} color={lightTheme.white} />
      </Div>
    </Pill>
  );
};
